import React, {Component} from 'react';

import strings from 'strings';
import {
	no_numbers,
	nn_numbers,
	no_numbers_more_items,
	nn_numbers_more_items,
} from './assets';
import listen from 'assets/listen.png';
import {getWorkingMemory, getOlderVersionWorkingMemory} from 'constants/tests';

import './styles.scss';
import {TYPES} from '../../constants/index';
import {
	createHowl,
	isLegacyIOS,
	playHowl,
	playSound,
	stopAllSounds,
} from 'utils/playSound';

class Test extends Component {
	constructor(props) {
		super(props);
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		const selectedVersion = isNormingTest
			? getWorkingMemory
			: getOlderVersionWorkingMemory;
		this.answerLengths = selectedVersion()
			.getNumberSteps()
			.map((row) => row.length);

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn_numbers;
				this.moreItemsAudio = nn_numbers_more_items;
				break;
			case 'no':
			default:
				this.assets = no_numbers;
				this.moreItemsAudio = no_numbers_more_items;
				break;
		}

		this.taskSounds = [];
		this.moreItemsSound = null;
		this.moreItemsEndHandler = null;
		this.useLegacyAudio = isLegacyIOS();
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		clearTimeout(this.timeout);
		this.disposeAudio();
	}

	initializeAudio = () => {
		this.preloadAudio();
		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	preloadAudio = () => {
		if (this.useLegacyAudio) return;

		this.taskSounds = this.assets.map((src) =>
			createHowl({
				src: [src],
				html5: false,
				preload: true,
			})
		);
		this.moreItemsSound = createHowl({
			src: [this.moreItemsAudio],
			html5: false,
			preload: true,
		});
	};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playNumbers(taskNumber);
	};

	playNumbers = (sound) => {
		const src = this.assets[sound];
		if (!src) return;

		if (this.useLegacyAudio) {
			if (this.shouldPlayMoreItemsAudio(sound)) {
				playSound(this.moreItemsAudio, {
					html5: true,
					onend: () => playSound(src, {html5: true}),
				});
			} else {
				playSound(src, {html5: true});
			}
			return;
		}

		const taskSound = this.taskSounds[sound];
		if (!taskSound) return;

		if (this.shouldPlayMoreItemsAudio(sound)) {
			const playTaskSound = () => {
				if (this.moreItemsSound) {
					this.moreItemsSound.off('end', playTaskSound);
				}
				this.moreItemsEndHandler = null;
				playHowl(taskSound);
			};

			this.moreItemsEndHandler = playTaskSound;
			this.moreItemsSound.once('end', playTaskSound);
			playHowl(this.moreItemsSound);
			return;
		}

		playHowl(taskSound);
	};

	shouldPlayMoreItemsAudio = (taskNumber) => {
		if (taskNumber <= 0) return false;

		return (
			this.answerLengths[taskNumber] >
			this.answerLengths[taskNumber - 1]
		);
	};

	stopSounds = () => {
		if (this.moreItemsSound && this.moreItemsEndHandler) {
			this.moreItemsSound.off('end', this.moreItemsEndHandler);
			this.moreItemsEndHandler = null;
		}
		stopAllSounds();
		this.taskSounds.forEach((sound) => sound && sound.stop());
		if (this.moreItemsSound) this.moreItemsSound.stop();
	};

	disposeAudio = () => {
		this.stopSounds();
		this.taskSounds.forEach((sound) => sound && sound.unload());
		if (this.moreItemsSound) this.moreItemsSound.unload();
		this.taskSounds = [];
		this.moreItemsSound = null;
	};

	render() {
		const {testKeyType, ageGroup} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				{!isNormingTest && <p>{strings.wsn_test1}</p>}
			</div>
		);
	}
}

export default Test;
